import { request } from './Request';
import { routes } from '../constants/constant.route';

const API_URL = process.env.REACT_APP_API_URL;

export default class ActivityReportService {

  static getActivityList() {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_ACTIVITY_LIST}`, null, null, null);
  }

  static addEditActivity(reqData) {
    let api = reqData.uuid ? routes.ACTIVITY_REPORT.EDIT_ACTIVITY : routes.ACTIVITY_REPORT.ADD_ACTIVITY;
    return request('POST', `${API_URL}${api}`, null, reqData, null);
  }

  static getActivity(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_ACTIVITY}`, reqData, null, null);
  }

  static getTotalActivityCount(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_TOTAL_ACTIVITY_COUNT}`, reqData, null, null);
  }

  static updateActivityTarget(reqData) {
    return request('POST', `${API_URL}${routes.ACTIVITY_REPORT.UPDATE_ACTIVITY_TARGET}`, null, reqData, null);
  }

  static getTotalActivityTarget(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_ACTIVITY_TARGET}`, reqData, null, null);
  }

  static getActivityReportZFM(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_ACTIVITY_REPORT_ZFM}`, reqData, null, null);
  }

  static getTotalActivityReportZFMCount(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_TOTAL_ACTIVITY_COUNT_REPORT_ZFM}`, reqData, null, null);
  }
  static deleteActivity(reqData) {
    return request('POST', `${API_URL}${routes.ACTIVITY_REPORT.DELETE_ACTIVITY}`, null, reqData, null);
  }

  static getBrand(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_BRAND}`, reqData, null, null);
  }

  static getPattern(reqData) {
    return request('GET', `${API_URL}${routes.ACTIVITY_REPORT.GET_BRAND_PATTERN}`, reqData, null, null);
  }
}